import * as React from 'react';
import cls from 'classnames';

import { useRoutes } from 'src/explore/hooks/useRoutes';

import styles from './index.module.sass';

interface Props {
  className?: string;
}

export const LiveClassSupport = ({ className }: Props ) => {
  const routes = useRoutes();

  return (
    <section className={cls( 'text-center spec__support', className )}>
      <h1 className={`${styles.headline} fs-5 fs-md-8 text-uppercase`}>For Questions</h1>

      <p className="mt-3">
        {'You can find our '}
        <a className={styles.link} href={routes.help.goldbellyLive()}>
          FAQ Page
        </a>
        {' with more information about our Goldbelly LIVE! experience.'}
      </p>
    </section>
  );
};
